module.exports = __webpack_public_path__ + "img/jxfw.8f8fa251.jpg";